import styled from 'styled-components';
import { grey, lightGray, lightGrayThird } from '../../assets/ui/colors';

export const BodyContainer = styled.div`
    background: white;
    border: 1px solid ${lightGrayThird};
    border-radius: 6px;
`;

export const MobileCard = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid ${lightGray};
    border-radius: 4px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.24);
    margin-bottom: 16px;
    padding: 12px;
`;

export const MobileCardTitle = styled.div`
    font-weight: 600;
`;

export const MobileCardDate = styled.div`
    color: ${grey};
    margin: 8px 0;
`;

export const MobileCardStatus = styled.div`
    margin-left: auto;
    color: ${props => props.color ? props.color : grey};
`;

export const ColorStatusBlock = styled.div`
    color: ${props => props.color ? props.color : grey};
`;

export const CloseIconBtn = styled.div`
    justify-content: center;
    align-items: center;
    text-align: center;
    display: flex;
    padding: 24px 4px;
    :hover {
        opacity: 0.5;
    }
`;

export const HeaderRow = styled.div`
    display: flex;
`;

export const MobileCardCloseIconBtn = styled.div`
    margin-left: auto;
    align-items: center;
    display: flex;
    cursor: pointer;
    :hover {
        opacity: 0.5;
    }
`;
